import z from 'zod';
export const reportReadyWebhookSchema = z.looseObject({
    type: z.literal('report-ready'),
    projectId: z.string(),
    reportId: z.string(),
    path: z.string(),
    bytes: z.number(),
});
//# sourceMappingURL=report-ready.webhook.js.map